import { render } from "./PropertiesSidebar.vue?vue&type=template&id=3c6f6215&scoped=true"
import script from "./PropertiesSidebar.vue?vue&type=script&lang=js"
export * from "./PropertiesSidebar.vue?vue&type=script&lang=js"

import "./PropertiesSidebar.vue?vue&type=style&index=0&id=3c6f6215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6f6215"]])

export default __exports__